import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployeeGrevienceRoutingModule } from './employee-grevience-routing.module';
import { GrievanceLinkComponent } from './grievance-link/grievance-link.component';
import { GrievanceDashboardComponent } from './grievance-dashboard/grievance-dashboard.component';
import { GrievanceUser1Component } from './grievance-user1/grievance-user1.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxEditorModule } from 'ngx-editor';
import { HighchartsChartModule } from 'highcharts-angular';
import { GrievanceDashboardRoutingModule } from '../Grievance-Dashboard/grievance-dashboard-routing.module';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { highchartsModules } from '../Grievance-Dashboard/grievance-dashboard.module';
import { User1Component } from './user1/user1.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { EmpGrievanceLinkComponent } from './emp-grievance-link/emp-grievance-link.component';
import { EmpGrievanceHeaderComponent } from './emp-grievance-header/emp-grievance-header.component';
import { EmpGrievanceFooterComponent } from './emp-grievance-footer/emp-grievance-footer.component';
import { AdminComponent } from './admin/admin.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';
import { SuperAdminDialogComponent } from './super-admin-dialog/super-admin-dialog.component';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';


@NgModule({
  declarations: [
    GrievanceLinkComponent,
    GrievanceDashboardComponent,
    GrievanceUser1Component,
    User1Component,
    SidebarComponent,
    EmpGrievanceLinkComponent,
    EmpGrievanceHeaderComponent,
    EmpGrievanceFooterComponent,
    AdminComponent,
    SuperAdminComponent,
    AdminDashboardComponent,
    SuperAdminDashboardComponent,
    SuperAdminDialogComponent
  ],
  imports: [
    CommonModule,
    EmployeeGrevienceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    ChartModule,
    MatTooltipModule,
    NgxEditorModule,
    HighchartsChartModule,
    AcademicFormModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatOptionModule
  ],
  exports:[
    EmpGrievanceHeaderComponent
  ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules }
  ]
})
export class EmployeeGrevienceModule { }
